import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BadgeColors, BadgeOptions } from '@src/app/components';
import { DECISION_TYPE_CODE } from '@src/constants';
import { UserService } from '@src/core/services';
import { PollUI } from '@src/models';

@Component({
  selector: 'new-list-item-poll',
  templateUrl: './list-item-poll.component.html',
  styleUrls: ['../styles/list-item.component.scss', './list-item-poll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListItemPollComponent {
  private readonly userService = inject(UserService);
  private readonly translateService = inject(TranslateService);

  @Input() set item(data: PollUI | undefined) {
    this.data = data;

    if (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Rejected) {
      this.badgeOptions = {
        size: 's',
        color: BadgeColors.Red,
        value: this.translateService.instant('components.listItemPolls.labels.rejected'),
      };
    } else if (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Passed) {
      this.badgeOptions = {
        size: 's',
        color: BadgeColors.Green,
        value: this.translateService.instant('components.listItemPolls.labels.passed'),
      };
    } else if (this.data?.dateEnd ? new Date(this.data?.dateEnd) < new Date() : true) {
      this.badgeOptions = {
        size: 's',
        color: BadgeColors.Grey,
        value: this.translateService.instant('components.listItemPolls.labels.completed'),
      };
    }
  }

  @Input() selectedId?: string;
  @Input() loading?: boolean;

  data?: PollUI;
  authUserId = this.userService.authUser?.id;
  badgeOptions?: BadgeOptions;

  isInvitation() {
    return (
      (this.data?.decisionTypeCode === DECISION_TYPE_CODE.Sended ||
        this.data?.decisionTypeCode === DECISION_TYPE_CODE.Readed) &&
      this.data?.status !== 5 &&
      (this.data?.dateEnd ? new Date(this.data?.dateEnd) >= new Date() : true)
    );
  }

  getColor() {
    if (this.isInvitation()) {
      return 'var(--unions-color-green)';
    }

    if (this.data?.createdBy === this.authUserId) {
      return 'var(--unions-color-blue-light)';
    }

    return '';
  }
}
